import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <section className="schedule-three ngo_list_wrapper ngo_lists">
      <div className="container">
        <div className="schedule-three__top">
          <div
            className="section-title text-center wow fadeInLeft"
            data-wow-delay="100ms"
          >
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">
                Last Updated: 06/01/2025
              </span>
            </div>
            <h2 className="section-title__title">ImpactUp - Privacy Policy</h2>
          </div>
        </div>
        <div className="schedule-three__bottom">
          <p className="event-two__text">
            ImpactUp (“we,” “our,” “us”) values your privacy and is committed to
            protecting your personal information. This Privacy Policy explains
            how we collect, use, and protect your data when you use our platform
            to create, host, or attend purpose-driven, community-focused events.
          </p>
          <p className="event-two__text">
            By using ImpactUp, you agree to the terms described in this Privacy
            Policy.
          </p>
          <p className="event-two__text">
            <strong>1. Information We Collect</strong>
            <br />
            We collect the following types of information:
            <br className="mt-2" />
            <p className="ms-4 mt-2">
              <strong>1.1 Information You Provide</strong>
              <ul className="ms-5">
                <li>
                  Account Information: Name, email address, phone number, and
                  profile details.
                </li>
                <li>
                  Communication: Messages you send via the platform, feedback,
                  or support requests.
                </li>
              </ul>
            </p>
            <p className="ms-4 mt-2">
              <strong>1.2 Information Collected Automatically</strong>
              <ul className="ms-5">
                <li>
                  Usage Data: Pages viewed, actions taken, and features used
                  within the platform.
                </li>
                <li>
                  Device Data: Browser type, operating system, and IP address.
                </li>
                <li>
                  Cookies & Tracking Technologies: To improve your user
                  experience and remember your preferences.
                </li>
              </ul>
            </p>
            <p className="ms-4 mt-2">
              <strong>1.3 Third-Party Data</strong>
              <ul className="ms-5">
                <li>
                  If you connect your account to a third-party service (e.g.,
                  social media sign-in), we may receive profile and contact
                  information from that service.
                </li>
              </ul>
            </p>
          </p>
          <p className="event-two__text">
            <strong>2. How We Use Your Information</strong>
            <br />
            We use your information to:
            <ul className="ms-5">
              <li>Provide and operate the ImpactUp platform.</li>
              <li>Help you create, host, and join events.</li>
              <li>
                Send event updates, reminders, and relevant notifications.
              </li>
              <li>Improve and customize the user experience.</li>
              <li>Ensure platform security and prevent fraud.</li>
              <li>Comply with legal obligations.</li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>3. How We Share Your Information</strong>
            <br />
            We do not sell your personal data to third parties.
            <br />
            We may share your information only in these cases:
            <ul className="ms-5">
              <li>
                With Event Hosts/Attendees: Limited details (e.g., your name and
                contact) to coordinate event participation.
              </li>
              <li>
                With Service Providers: Trusted vendors who help operate our
                platform (e.g., cloud hosting, analytics).
              </li>
              <li>
                For Legal Reasons: If required by law, regulation, or court
                order.
              </li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>4. Data Security</strong>
            <br />
            We implement reasonable security measures to protect your personal
            information against unauthorized access, use, or disclosure.
            However, no method of transmission over the internet is 100% secure.
          </p>
          <p className="event-two__text">
            <strong>5. Your Rights & Choices</strong>
            <br />
            You have the right to:
            <ul className="ms-5">
              <li>Access and update your personal information.</li>
              <li>Request deletion of your account.</li>
              <li>Manage your notification preferences.</li>
              <li>Opt-out of certain data processing activities.</li>
              <li>
                To exercise your rights, contact us at{" "}
                <a href="mailto:support@impactup.ai">support@impactup.ai</a>.
              </li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>6. Cookies & Tracking</strong>
            <br />
            ImpactUp uses cookies and similar technologies to:
            <ul className="ms-5">
              <li>Keep you signed in.</li>
              <li>Save your preferences.</li>
              <li>Analyze site usage to improve our services.</li>
              <li>You can control cookies through your browser settings.</li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>7. Changes to This Privacy Policy</strong>
            <br />
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with a revised “Last Updated” date.
          </p>
          <p className="event-two__text">
            <strong>8. Contact Us</strong>
            <br />
            If you have questions or concerns about this Privacy Policy, contact
            us at <a href="mailto:support@impactup.ai">support@impactup.ai</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
